import type { CommandResult } from '@travel-planner/shared/schemas';
import type { ComponentType } from 'react';

export type ResultRendererProps = { result: CommandResult };
export type ResultRenderer = ComponentType<ResultRendererProps>;

const registry = new Map<string, ResultRenderer>();

export const registerResultRenderer = (
  kind: string,
  renderer: ResultRenderer
): void => {
  registry.set(kind, renderer);
};

export const getResultRenderer = (kind: string): ResultRenderer | undefined =>
  registry.get(kind);

export const __resetResultRendererRegistryForTests = (): void => {
  registry.clear();
};
